/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { GridApi, IRowNode } from 'ag-grid-community';

export class GridRowEvent<T> {
  node: IRowNode;
  rowIndex: number;
  data: T;
  context: any;
  api: GridApi;
}

export interface GridSelectedRowChangeEvent<T> {
  id?: any;
  node?: IRowNode;
  data?: T;
}
